import styled from 'styled-components';

import { FlexRow } from 'styles/layouts';

export const TeamSelectorWrapper = styled(FlexRow)`
  margin-left: var(--spacing-8);
`;

export const TeamsContainer = styled(FlexRow)`
  width: 206px;
  justify-content: space-between;
  align-items: center;
  padding: var(--spacing-12);
  cursor: pointer;

  &:hover {
    background: var(--color-bg-fill-hover);
  }
`;

export const SelectedAccount = styled(TeamsContainer)`
  border: 1px solid var(--color-border);
  border-radius: var(--border-radius-12);
`;
